var _InputTypes, _CircleSizes, _CircleFontsForSizes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Text } from '@doordash/design-language';
export var Types = {
  Custom: 'CUSTOM',
  Toggle: 'TOGGLE',
  Checkbox: 'CHECKBOX',
  Radio: 'RADIO',
  Circle: 'CIRCLE'
};
export var InputTypesRaw = {
  Checkbox: 'checkbox',
  Radio: 'radio'
};
export var Alignment = {
  Start: 'flex-start',
  Center: 'center',
  End: 'flex-end',
  Baseline: 'baseline'
};
export var Justification = {
  Start: 'flex-start',
  Center: 'center',
  End: 'flex-end'
};
export var InputTypes = (_InputTypes = {}, _defineProperty(_InputTypes, Types.Toggle, 'checkbox'), _defineProperty(_InputTypes, Types.Checkbox, 'checkbox'), _defineProperty(_InputTypes, Types.Radio, 'radio'), _defineProperty(_InputTypes, Types.Circle, 'checkbox'), _InputTypes);
export var Sizes = {
  Small: 20,
  Large: 24
};
export var CircleSizes = (_CircleSizes = {}, _defineProperty(_CircleSizes, Sizes.Small, 32), _defineProperty(_CircleSizes, Sizes.Large, 64), _CircleSizes);
export var LabelSides = {
  Leading: 'Leading',
  Trailing: 'Trailing'
};
export var CircleFontsForSizes = (_CircleFontsForSizes = {}, _defineProperty(_CircleFontsForSizes, CircleSizes[Sizes.Small], Text.Styles.Medium12), _defineProperty(_CircleFontsForSizes, CircleSizes[Sizes.Large], Text.Styles.Medium16), _CircleFontsForSizes);
export var TRANSITION_TIME = '0.15s';